import React from 'react'
import { Stack, Chip, Skeleton, Grid } from '@mui/material'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetAlbumQuery } from '../../api/albumApiSlice'
import AlbumSideMenu from './components/board/AlbumSideMenu'

const chipStyle = { 
    color:'#fff',
    height: '2.8vh',
    borderRadius: '1.3vh',
    borderColor: '#ffffff',
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    background: '#))))))',
    '& span': {padding: '0 18px'}
}

const AlbumBoard = () => {
    let { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    const {
        data: albumLiked
    } = useGetAlbumQuery({id})

    const showTracks = () => {
        navigate('tracks')
    }

    const showTeam = () => {
        navigate('team')
    }

    const showStats = () => {
        navigate('stats')
    }


    return albumLiked 
    ?
        <Grid container spacing={2} sx={{height: '100%', pb: {xs:'17%', md:'5%', lg: 0}}}>
            <AlbumSideMenu />
            <Grid size={{ lg: 8, xs: 12}} sx={{height:  {xs:'65%', md:'50%',lg:'100%'}, position: 'relative', borderRadius: '16px', }}>
                <Stack direction={'column'} sx={{borderRadius: '16px', width:'100%', height: '100%', backdropFilter: 'blur(40px)  brightness(70%)'}}>
                    <Stack direction={'row'} spacing={2} alignSelf={'center'} sx={{overflowY: 'hidden', overflowX: 'hidden', m:2, height: '4vh'}}>
                        <Chip 
                            key={'Tracks'} 
                            label={'Tracks'} 
                            variant={!location.pathname.includes('team') && !location.pathname.includes('stats') ? 'outlined' : 'filled' } 
                            onClick={showTracks}sx={chipStyle}/>
                        <Chip 
                            key={'Équipe'} 
                            label={'Équipe'} 
                            variant={location.pathname.includes('team')? 'outlined' : 'filled' } 
                            onClick={showTeam} sx={chipStyle}/>
                        <Chip 
                            key={'Statistiques'} label={'Statistiques'} 
                            variant={location.pathname.includes('stats') ? 'outlined' : 'filled' } 
                            onClick={showStats} sx={chipStyle}/>
                    </Stack>
                    <Outlet />
                </Stack>
            </Grid>   
        </Grid>
    : 
        <Skeleton />
}




export default AlbumBoard